export enum AnimalOrCell {
  ANIMAL = 'ANIMAL',

  CELL = 'CELL',

  PLANT = 'PLANT',

  PROTEIN = 'PROTEIN',
}
